/**
 * Mostrar un importe.
 *
 * **Es sólo presentación.** La aritmética vive en `Importe` de `@actualgold/shared` y no pasa por
 * acá: esto recibe el texto exacto que produjo esa aritmética y decide cómo se ve.
 *
 * Lo que agrega es el separador de miles, y no es cosmético: `205408.00` obliga a contar dígitos
 * para saber si son doscientos mil o dos millones, y en un tablero que se mira de reojo eso es
 * exactamente lo que no puede pasar. La cuenta la hace `Intl` con el idioma activo, así que en
 * español sale `205.408,00` y en inglés `205,408.00`.
 */
export function importeParaMirar(importe: string, idioma: string): string {
  const [entera = '0', fraccion = ''] = importe.split('.');
  const negativo = entera.startsWith('-');
  const digitos = entera.replace('-', '');

  // Los enteros se agrupan con `Intl` y los decimales se pegan a mano: convertir el número a
  // coma flotante para formatearlo sería meter el redondeo del navegador en un importe exacto,
  // que es justo lo que la regla 2 prohíbe.
  const agrupados = new Intl.NumberFormat(idioma).format(BigInt(digitos === '' ? '0' : digitos));
  const separador = new Intl.NumberFormat(idioma).format(1.5).charAt(1);
  return `${negativo ? '-' : ''}${agrupados}${separador}${fraccion.padEnd(2, '0').slice(0, 2)}`;
}
